import {createContext} from "react";
import Page from "../../api/Page";
import Folder from "../../api/folder/Folder";
import GetListFolderQuery from "../../api/folder/GetListFolderQuery";
import GetListQuery from "../../api/vcard/GetListQuery";
import CreateFolderPayload from "../../api/folder/CreateFolderPayload";

/**
 * @author Kacper Faber
 * @since 0.1.7
 */
type FolderContextType = {
    /**
     * Data
     * @author Kacper Faber
     * @since 0.1.7
     */
    folders?: Page<Folder>;

    /**
     * Current query.
     * @author Kacper Faber
     * @since 0.1.7
     */
    query: GetListFolderQuery;

    /**
     * Updates query in context.
     * @author Kacper Faber
     * @since 0.1.7
     * @param query Query to set
     */
    setQuery: (query: GetListQuery) => void;

    /**
     * Is fetching?
     * @author Kacper Faber
     * @since 0.1.7
     */
    isFetching: boolean;

    /**
     * Force reload.
     * @author Kacper Faber
     * @since 0.1.8
     */
    reload: () => void;

    /**
     * Deletes folder from API, if success - reloads the state.
     * @author Kacper Faber
     * @since 0.1.8
     * @param id
     */
    deleteFolder: (id: string | number) => Promise<void>;

    /**
     * Creates new folder in API.
     * Will refresh data if succeeded.
     * @author Kacper Faber
     * @since 0.1.8
     * @param payload
     */
    create: (payload: CreateFolderPayload) => Promise<Folder>;
};

const notImplementedMethod = () => {
    throw new Error("Not Implemented");
}

/**
 * Default initial value for FolderContext.
 * @author Kacper Faber
 * @since 0.1.7
 */
const defaults: FolderContextType = {
    folders: undefined,
    query: {},
    setQuery: notImplementedMethod,
    isFetching: false,
    reload: notImplementedMethod,
    deleteFolder: notImplementedMethod,
    create: notImplementedMethod
};

/**
 * Folder context.
 * To be used in layout and in some pages.
 * @author Kacper Faber
 * @since 0.1.7
 */
const folderContext = createContext<FolderContextType>(defaults);

export default folderContext;